export const COLORS = {
  brown5: 'brown-5',
  brown4: 'brown-4',
  brown3: 'brown-3',
  brown2: 'brown-2',
  brown: 'brown',
}

export const HOME_PRODUCT_POSITIONS = {
  0: { color: COLORS.brown4, pos: 0 },
  1: { color: COLORS.brown2, pos: 3 },
  2: { color: COLORS.brown, pos: 4 },
  3: { color: COLORS.brown5, pos: 7 },
  4: { color: COLORS.brown, pos: 9 },
  5: { color: COLORS.brown2, pos: 11 },
  6: { color: COLORS.brown4, pos: 13 },
  7: { color: COLORS.brown, pos: 15 },
  8: { color: COLORS.brown5, pos: 19 },
  9: { color: COLORS.brown2, pos: 21 },
  10: { color: COLORS.brown4, pos: 24 },
  11: { color: COLORS.brown5, pos: 28 },
  12: { color: COLORS.brown, pos: 32 },
  13: { color: COLORS.brown5, pos: 34 },
  14: { color: COLORS.brown2, pos: 37 },
  15: { color: COLORS.brown3, pos: 38 },
  16: { color: COLORS.brown5, pos: 41 },
  17: { color: COLORS.brown2, pos: 43 },
  18: { color: COLORS.brown2, pos: 45 },
  19: { color: COLORS.brown2, pos: 47 },
  20: { color: COLORS.brown5, pos: 49 },
  21: { color: COLORS.brown, pos: 52 },
  22: { color: COLORS.brown4, pos: 56 },
  23: { color: COLORS.brown5, pos: 58 },
  24: { color: COLORS.brown5, pos: 62 },
  25: { color: COLORS.brown, pos: 65 },
  26: { color: COLORS.brown4, pos: 69 },
  27: { color: COLORS.brown, pos: 71 },
  28: { color: COLORS.brown3, pos: 75 },
  29: { color: COLORS.brown, pos: 77 },
  30: { color: COLORS.brown4, pos: 81 },
  31: { color: COLORS.brown5, pos: 84 },
  32: { color: COLORS.brown3, pos: 88 },
  33: { color: COLORS.brown2, pos: 90 },
  34: { color: COLORS.brown4, pos: 91 },
  35: { color: COLORS.brown, pos: 95 },
  36: { color: COLORS.brown2, pos: 98 },
  37: { color: COLORS.brown4, pos: 102 },
  38: { color: COLORS.brown, pos: 104 },
  39: { color: COLORS.brown5, pos: 108 },
  40: { color: COLORS.brown2, pos: 112 },
  41: { color: COLORS.brown4, pos: 114 },
  42: { color: COLORS.brown, pos: 116 },
  43: { color: COLORS.brown5, pos: 119 },
  44: { color: COLORS.brown4, pos: 123 },
  45: { color: COLORS.brown5, pos: 125 },
  46: { color: COLORS.brown4, pos: 127 },
}
